import React from "react";
import "./star-rating.scss";

interface StarRatingProps {
  rating: number; // Current rating value
  onRatingChange: (rating: number) => void; // Callback to update the rating
}

const StarRating: React.FC<StarRatingProps> = ({ rating, onRatingChange }) => {
  const handleStarClick = (index: number) => {
    onRatingChange(index);
  };

  const handleStarHover = (index: number) => {
    onRatingChange(index);
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((value, index) => (
        <span
          key={index}
          className={`star ${rating >= value ? "filled" : ""}`}
          onClick={() => handleStarClick(value)}
          onMouseEnter={() => handleStarHover(value)}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
